import { Maybe, PaginationResponse } from '@aibees/shared/definition';
import { SuggestionSearchBarOptionBase } from '@aibees/elephant/feature/suggestion-search-bar';
import { useBrowsePeopleApi } from './use-browse-people-api';

export function useAutoSuggestedPeople(search: Maybe<string>) {
  return useBrowsePeopleApi(
    {
      return: 'linkedin',
      ...(search && { search }),
      size: 10,
      page: 0,
    },
    {
      select: (data) => {
        const content = data?.content.map(
          (x) =>
            ({
              canSimilaritySearch: x.canSimilaritySearch,
              id: x.id,
              value: x.url,
              label: x.name,
              logo: x.logo,
              description: x.title,
              fullData: x,
            } as SuggestionSearchBarOptionBase)
        ) as SuggestionSearchBarOptionBase[];
        return {
          ...data,
          ...{ content },
        } as PaginationResponse<SuggestionSearchBarOptionBase>;
      },
    }
  );
}
